import React from 'react';
import { Grid, Typography, Button } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import { Link as RouterLink } from 'react-router-dom';

function OurSolutionsConnect() {
  const globalClasses = globalUseStyles()
  return (
    <ThemeProvider theme={theme}>
      <Container className={"connectStyle"} maxWidth={false} component="section">
          <Container className={"connectStyleInner"} maxWidth={false} component="section">
            <Grid className={globalClasses.containerSmall} container >
                <Grid item xs={12} md={12} className={globalClasses.containerVertPadding}  >
                  <Typography variant="h3">Interested in learning more about us? We’d love to connect!</Typography>
                  <Button className={'secondaryButton'} variant="outlined" color="inherit" to='/contact' component={RouterLink}>Connect with us</Button>
                </Grid>
            </Grid>
          </Container>
      </Container>
    </ThemeProvider>
  );
};

export default OurSolutionsConnect;